/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReportTabs200ResponseItemsInner
 */
export interface GetReportTabs200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetReportTabs200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof GetReportTabs200ResponseItemsInner
     */
    activationOrSchedulingTime: Date;
    /**
     * 
     * @type {string}
     * @memberof GetReportTabs200ResponseItemsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportTabs200ResponseItemsInner
     */
    status: GetReportTabs200ResponseItemsInnerStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetReportTabs200ResponseItemsInner
     */
    amount: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetReportTabs200ResponseItemsInner
     */
    payments: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GetReportTabs200ResponseItemsInner
     */
    tips: number;
    /**
     * 
     * @type {number}
     * @memberof GetReportTabs200ResponseItemsInner
     */
    discounts: number;
}


/**
 * @export
 */
export const GetReportTabs200ResponseItemsInnerStatusEnum = {
    Incomplete: 'incomplete',
    Pending: 'pending',
    Paid: 'paid',
    Refunded: 'refunded',
    PartiallyRefunded: 'partiallyRefunded'
} as const;
export type GetReportTabs200ResponseItemsInnerStatusEnum = typeof GetReportTabs200ResponseItemsInnerStatusEnum[keyof typeof GetReportTabs200ResponseItemsInnerStatusEnum];


/**
 * Check if a given object implements the GetReportTabs200ResponseItemsInner interface.
 */
export function instanceOfGetReportTabs200ResponseItemsInner(value: object): value is GetReportTabs200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('activationOrSchedulingTime' in value) || value['activationOrSchedulingTime'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('payments' in value) || value['payments'] === undefined) return false;
    if (!('tips' in value) || value['tips'] === undefined) return false;
    if (!('discounts' in value) || value['discounts'] === undefined) return false;
    return true;
}

export function GetReportTabs200ResponseItemsInnerFromJSON(json: any): GetReportTabs200ResponseItemsInner {
    return GetReportTabs200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetReportTabs200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTabs200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'activationOrSchedulingTime': (new Date(json['activationOrSchedulingTime'])),
        'name': json['name'],
        'status': json['status'],
        'amount': json['amount'],
        'payments': json['payments'],
        'tips': json['tips'],
        'discounts': json['discounts'],
    };
}

export function GetReportTabs200ResponseItemsInnerToJSON(json: any): GetReportTabs200ResponseItemsInner {
    return GetReportTabs200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetReportTabs200ResponseItemsInnerToJSONTyped(value?: GetReportTabs200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'activationOrSchedulingTime': ((value['activationOrSchedulingTime']).toISOString()),
        'name': value['name'],
        'status': value['status'],
        'amount': value['amount'],
        'payments': value['payments'],
        'tips': value['tips'],
        'discounts': value['discounts'],
    };
}

